<script setup lang="ts">
import { computed } from 'vue';

import { useStation, type Coupon } from '@/store/station';
import { useUserStore } from '@/store/user';
import { useI18n } from 'vue-i18n';

const station = useStation();
const { t } = useI18n();
const user = useUserStore();

const is_station_available = computed(() => {
  console.log(`[station-details]: charging: ${station.charging}`);
  return !station.charging;
});

const show_price = computed(() => {
  return user.is_guest && station.accept_guests;
});

const price = computed(() => {
  let coupon: Coupon | null = station.coupon;
  let base_cents = station.price ?? 0;
  if (!!coupon) {
    switch (coupon.ctype) {
    case "FREE":
      return "free";
    case "PERCENT":
      base_cents *= parseFloat(coupon.metadata?.percentage_reduction ?? "100") / 100;
      break;
    case "FIXED":
      base_cents = parseInt(coupon.metadata?.price ?? `${base_cents}`);
      break;
    }
  }
  return `${((base_cents) / 100).toFixed(2)} €/kWh`;

});
</script>

<template>
  <v-card class="pa-0" flat color="white">
    <v-card-title class="body-2 pa-1">
      <v-layout justify-space-between>
        <div class="text-no-wrap text-secondary text-body-2">
          {{ t("informations") }}
        </div>
        <v-tooltip location="bottom">
          <template #activator="{ props }">
            <v-icon class="ml-3" size="x-small" v-bind="props">
              custom:type2-connector
            </v-icon>
          </template>
          <span>{{ t("plug_type.type2") }}</span>
        </v-tooltip>
      </v-layout>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-1">
      <v-col class="text-wrap">
        <v-row class="align-center">
          <template v-if="is_station_available">
            <v-icon class="mr-2 text-success">
              mdi-checkbox-marked-circle
            </v-icon>
            <div class="text-no-wrap text-secondary">
              {{ t("available") }}
            </div>
          </template>
          <template v-else>
            <v-icon class="mr-2 text-error">mdi-close-circle</v-icon>
            <div class="text-no-wrap text-secondary">
              {{ t("unavailable") }}
            </div>
          </template>
        </v-row>
        <v-row
          v-if="show_price"
          class="text-no-wrap font-weight-bold text-secondary"
        >
          <v-icon class="mr-2">mdi-credit-card-outline</v-icon>
          {{ price }}
          <!-- €/kWh -->
        </v-row>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<i18n lang="yaml">
en:
  available: Available
  informations: Informations
  plug_type:
    type2: Type 2
  unavailable: Unavailable
it:
  available: Disponible
  informations: Informazioni
  plug_type:
    type2: Tipo 2
  unavailable: Non disponibile
fr:
  available: Disponible
  informations: Informations
  plug_type:
    type2: Type 2
  unavailable: Indisponible
de:
  available: Erhältlich
  informations: Information
  plug_type:
    type2: Typ 2
  unavailable: Nicht erhältlich
nl:
  available: Beschikbaar
  informations: Informatie
  plug_type:
    type2: Type 2
  unavailable: Niet beschikbaar
es:
  available: Disponible
  informations: Información
  plug_type:
    type2: Tipo 2
  unavailable: No disponible
</i18n>

<style scoped>

</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
